<ng-container *transloco="let t; read: 'cookie-banner'">
  <p-dialog
    [(visible)]="showBanner"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [showHeader]="false"
    [style]="{ width: '90vw', maxWidth: '1200px' }"
    [position]="'bottom'"
    [blockScroll]="false"
    [dismissableMask]="false"
    [closeOnEscape]="false"
    styleClass="cookie-banner-dialog"
  >
    <div class="cookie-banner-content">
      <div class="cookie-banner-text">
        <p>{{ t('message') }}</p>
      </div>
      <div class="cookie-banner-actions">
        <button pButton severity="secondary" [label]="t('learn_more')" class="p-button-text" (click)="showCookiePolicy()"></button>
        <button pButton severity="primary" [label]="t('accept')" (click)="acceptCookies()"></button>
      </div>
    </div>
  </p-dialog>

  <p-dialog
    [(visible)]="showPolicyDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [header]="t('policy_title')"
    [style]="{ width: '600px', maxHeight: '80vh' }"
  >
    <div class="cookie-policy-content">
      <p>{{ t('policy_intro') }}</p>

      <h4>{{ t('technical_cookies_title') }}</h4>
      <p>{{ t('technical_cookies_description') }}</p>

      <ul>
        <li>
          <strong>{{ t('auth_cookie') }}:</strong>
          {{ t('auth_cookie_desc') }}
        </li>
        <li>
          <strong>{{ t('session_cookie') }}:</strong>
          {{ t('session_cookie_desc') }}
        </li>
        <li>
          <strong>{{ t('preferences_cookie') }}:</strong>
          {{ t('preferences_cookie_desc') }}
        </li>
        <li>
          <strong>{{ t('consent_cookie') }}:</strong>
          {{ t('consent_cookie_desc') }}
        </li>
      </ul>

      <h4>{{ t('manage_cookies_title') }}</h4>
      <p>{{ t('manage_cookies_description') }}</p>
    </div>
  </p-dialog>
</ng-container>
